import React from "react"
import { getStructuredHeadingTypo } from "@/components/common/StructuredText/components/Heading"
import Text from "@/components/common/Text"

const Heading = ({ node, color, children }) => {
	const { type, level } = node
	const tag = `${type.substring(0, 1)}${level}`
	const typo = getStructuredHeadingTypo(level)
	return (
		<Text as={tag} color={color} className={`${typo}`}>
			{children}
		</Text>
	)
}

export default Heading
